import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const Container = styled.div`
  position: fixed;
  right: 2rem;
  z-index: 50;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  color: white;

  ${({ alertStyle }) =>
    alertStyle == "default" &&
    css`
      bottom: 19.5rem;
      padding: 2rem;
      border-radius: 1rem;
      justify-content: space-between;

      ${breakpoint("tablet")`
        bottom: 7rem;
      `}

      & > :last-child {
        margin-left: 1rem;
      }

      ${({ variant, theme }) =>
        variant === "success" &&
        css`
          background-color: ${theme.colors.success};
        `}

      ${({ variant, theme }) =>
        variant === "info" &&
        css`
          background-color: ${theme.colors.secondary};
        `}

      ${({ variant, theme }) =>
        variant === "error" &&
        css`
          background-color: ${theme.colors.danger};
        `}
    `}

  ${({ alertStyle }) =>
    alertStyle == "simple" &&
    css`
      padding: 10px 16px;
      gap: 12px;
      border-radius: 8px;
      justify-content: start;
      right: 1rem;
      bottom: 1rem;
      box-shadow: 1px 1px 5px #888;

      ${breakpoint("tablet")`
        max-width: 50%;
        max-width: 50vw;
        bottom: 4.8rem;
      `}

      ${breakpoint("desktop")`
        max-width: 23%;
        max-width: 23vw;
      `}

      p {
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
      }

      ${({ variant, theme }) =>
        variant === "success" &&
        css`
          background-color: ${theme.colors.alerts.success};
        `}

      ${({ variant, theme }) =>
        variant === "info" &&
        css`
          background-color: ${theme.colors.alerts.info};
        `}

      ${({ variant, theme }) =>
        variant === "error" &&
        css`
          background-color: ${theme.colors.alerts.danger};
        `}
    `}
`
